export enum ModuleInputType {
    Integer = 'Integer',
    Number = 'Number',
    String = 'String',
    Range = 'Range',
    File = 'File',
    ListFile = 'ListFile',
    FileInput = 'FileInput',
    ChoiceBinary = 'ChoiceBinary',
    ChoiceSingle = 'ChoiceSingle',
}
